(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('contactsTest', contactsTest);

    /* @ngInject */
    function contactsTest() {
        var directive = {
            bindToController: true,
            templateUrl: 'contacts-test.tpl',
            controller: contactsTestCtrl,
            controllerAs: '$ctrl',
            link: link,
            restrict: 'E',
            scope: {
                data: '<'
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }

    }

    /* @ngInject */
    function contactsTestCtrl($scope, $http) {

        $scope.$ctrl.response = null;

        $scope.$ctrl.getContacts = function() {
            $http({
                method: 'POST',
                url: ajaxurl,
                data: { action: 'gmail_action' }
            }).then(
                // success callback
                function(response) {
                    console.log(['success gmail_action', response]);
                    $scope.$ctrl.response = response.data;
                },
                // failure callback
                function(response) {
                    console.log(['failure gmail_action', response]);
                    $scope.$ctrl.response = response.data;
                }
            );
        };

    }

})();
